// Suggest a booked supplier account in the manual purchase editor. The suggestion
// never changes VAT and is limited to Norwegian businesses, like receipt memory.
(function initManualPurchaseAccountSuggestion(global) {
  const clean = (value) => String(value || '').trim();
  const org = (value) => clean(value).replace(/\D/g, '');
  const name = (value) => clean(value).toLocaleLowerCase('nb-NO')
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  const code = (value) => clean(value).replace(/\D/g, '').slice(0, 4);
  const active = (expense) => !['annulled', 'reversed', 'deleted', 'draft']
    .includes(clean(expense?.status).toLowerCase()) && !expense?.annulledAt;
  const sameSupplier = (expense, supplier) => {
    const wantedOrg = org(supplier?.org || supplier?.organizationNumber);
    const expenseOrg = org(expense?.supplierOrganizationNumber);
    if (wantedOrg.length >= 8) return wantedOrg === expenseOrg;
    const wantedName = name(supplier?.name);
    return wantedName.length >= 3 && name(expense?.supplierName) === wantedName;
  };
  const bookedChoice = (expense) => {
    const line = (Array.isArray(expense?.purchaseLines) ? expense.purchaseLines : [])
      .find((candidate) => candidate?.costAccountCode || candidate?.accountCode) || expense;
    const accountCode = code(line?.costAccountCode || line?.accountCode || expense?.costAccountCode);
    const vatRate = Number(line?.vatRate ?? expense?.vatRate ?? 0);
    const reverseChargeCode = clean(line?.reverseChargeCode || expense?.reverseChargeCode);
    return accountCode && Number.isFinite(vatRate)
      ? { accountCode, vatRate, reverseChargeCode: ['81', '86'].includes(reverseChargeCode) ? reverseChargeCode : '' }
      : null;
  };
  const resolve = ({ state, supplier, availableAccountCodes } = {}) => {
    if (!clean(supplier?.name)) return null;
    const allowed = availableAccountCodes instanceof Set ? availableAccountCodes : new Set();
    const explicit = code(supplier?.defaultCostAccountCode);
    if (explicit && (allowed.size === 0 || allowed.has(explicit))) return { accountCode: explicit, origin: 'supplier-default' };
    if (clean(state?.settings?.country).toUpperCase() !== 'NO') return null;
    const counts = new Map();
    (Array.isArray(state?.expenses) ? state.expenses : []).filter(active)
      .filter((expense) => sameSupplier(expense, supplier))
      .forEach((expense) => {
        const choice = bookedChoice(expense);
        if (!choice || (allowed.size && !allowed.has(choice.accountCode))) return;
        const key = [choice.accountCode, choice.vatRate, choice.reverseChargeCode].join(':');
        const current = counts.get(key) || { ...choice, count: 0 };
        current.count += 1;
        counts.set(key, current);
      });
    const ranked = [...counts.values()].sort((left, right) => right.count - left.count);
    if (!ranked[0] || ranked[0].count < 2 || ranked[1]?.count === ranked[0].count) return null;
    return { accountCode: ranked[0].accountCode, origin: 'supplier-history', count: ranked[0].count };
  };
  const apply = ({ lines, previousSuggestedByLine = {}, suggestion } = {}) => {
    const nextSuggestedByLine = {};
    const nextLines = (Array.isArray(lines) ? lines : []).map((line, index) => {
      const id = String(line.id);
      const previouslySuggested = previousSuggestedByLine[id] === code(line.costAccountCode);
      const base = previouslySuggested ? { ...line, costAccountCode: '' } : line;
      if (!suggestion?.accountCode || clean(base.costAccountCode) || (suggestion.origin === 'supplier-history' && index > 0)) return base;
      nextSuggestedByLine[id] = suggestion.accountCode;
      return { ...base, costAccountCode: suggestion.accountCode };
    });
    return { lines: nextLines, suggestedByLine: nextSuggestedByLine };
  };
  global.PlummeManualPurchaseAccountSuggestion = { resolve, apply };
})(typeof window !== 'undefined' ? window : globalThis);
